/* src/components/project-library-items/project-library-items.component.scss */
:host {
  display: block;
}
.search-theme,
.search-action-holder,
.search-status,
.search-filled-in {
  width: 15rem;
  margin: 0 0 0 var(--vwui-size-spacing-xs);
}
.badge--right {
  margin: 0;
}
.grid-layout {
  display: grid;
  justify-items: stretch;
  grid-template-columns: repeat(auto-fit, calc(25% - 0.9rem));
  grid-gap: 1.2rem;
}
.footer-status {
  line-height: 2.5rem;
  display: inline-block;
}
.footer-status:before {
  content: "";
  display: block;
  float: left;
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  margin: 1.15rem 0.6rem 0 0;
  background: var(--vwui--color--primary);
}
.footer-status--proposed {
  line-height: 2rem;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  border-radius: 4px;
  border: 1px solid var(--vwui--color--primary);
  color: var(--vwui--color--primary);
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.footer-status--proposed:before {
  display: none;
}
.footer-actions {
  float: right;
  margin: 0.6rem 0 0 0;
}
/*# sourceMappingURL=project-library-items.component-4ZC4V4H7.css.map */
